import React, { useState } from 'react';
import { useAuth } from '@/auth/AuthContext';
import { ApiError, api } from '@/lib/api';

/**
 * Личный кабинет → «Профиль». ФИО и email — read-only (правит школа в
 * админке). Здесь же — смена собственного пароля: текущий + новый +
 * подтверждение. Бэк: POST /api/auth/password-change.
 */
export default function ParentProfilePage() {
  const { user } = useAuth();

  const [current, setCurrent] = useState('');
  const [next, setNext]       = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState(null);
  const [success, setSuccess] = useState(false);
  const [showPw, setShowPw]   = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null); setSuccess(false);
    if (next.length < 8) {
      setError('Новый пароль должен быть не короче 8 символов');
      return;
    }
    if (next !== confirm) {
      setError('Новый пароль и подтверждение не совпадают');
      return;
    }
    if (current === next) {
      setError('Новый пароль совпадает со старым');
      return;
    }
    setSaving(true);
    try {
      await api.post('/api/auth/password-change', {
        currentPassword: current,
        newPassword: next,
      });
      setSuccess(true);
      setCurrent(''); setNext(''); setConfirm('');
    } catch (e2) {
      setError(e2 instanceof ApiError ? e2.message : 'Не удалось сменить пароль');
    } finally {
      setSaving(false);
    }
  };

  const inputType = showPw ? 'text' : 'password';

  return (
    <div className="pc-body">
      <div className="pc-card" style={{ maxWidth: 560 }}>
        <div className="pc-card__head">
          <div className="pc-card__title">Личные данные</div>
        </div>
        <div className="pc-card__body">
          <div className="pc-profile__field">
            <div className="pc-profile__label">ФИО</div>
            <div className="pc-profile__value">{user?.name || '—'}</div>
            <div className="pc-profile__hint">
              Если что-то указано неверно — напишите администратору школы в чате.
            </div>
          </div>
          <div className="pc-profile__field">
            <div className="pc-profile__label">Email</div>
            <div className="pc-profile__value">{user?.email || '—'}</div>
          </div>
        </div>
      </div>

      <form className="pc-card" style={{ maxWidth: 560 }} onSubmit={onSubmit}>
        <div className="pc-card__head">
          <div className="pc-card__title">Смена пароля</div>
        </div>
        <div className="pc-card__body" style={{ display: 'grid', gap: 12 }}>
          <label className="pc-profile__field">
            <div className="pc-profile__label">Текущий пароль</div>
            <input
              type={inputType}
              className="pc-profile__input"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              autoComplete="current-password"
              required
              disabled={saving}
            />
          </label>

          <label className="pc-profile__field">
            <div className="pc-profile__label">Новый пароль</div>
            <input
              type={inputType}
              className="pc-profile__input"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
              disabled={saving}
            />
            <div className="pc-profile__hint">Минимум 8 символов.</div>
          </label>

          <label className="pc-profile__field">
            <div className="pc-profile__label">Повторите новый пароль</div>
            <input
              type={inputType}
              className="pc-profile__input"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
              disabled={saving}
            />
          </label>

          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, color: 'var(--pc-fg-muted)' }}>
            <input
              type="checkbox"
              checked={showPw}
              onChange={(e) => setShowPw(e.target.checked)}
            />
            Показать пароли
          </label>

          {error && (
            <div className="pc-profile__error">{error}</div>
          )}
          {success && (
            <div className="pc-profile__success">Пароль успешно изменён.</div>
          )}

          <div style={{ display: 'flex', gap: 8 }}>
            <button
              type="submit"
              className="pc-profile__submit"
              disabled={saving || !current || !next || !confirm}
            >
              {saving ? 'Сохраняем…' : 'Сменить пароль'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
